export default function SortedTableHeader({
                                              field,
                                              label,
                                              sort,
                                              onSort,
                                              className = ''
                                          }) {
    const isActive = sort.field === field

    const icon = isActive
        ? sort.direction === 'ASC'
            ? ' ↑'
            : ' ↓'
        : ''

    return (
        <th
            onClick={() => onSort(field)}
            className={`px-6 py-3 text-left text-xs font-medium uppercase cursor-pointer hover:bg-gray-100 select-none
        ${isActive ? 'text-gray-900' : 'text-gray-500'}
        ${className}`}
        >
            {label}{icon}
        </th>
    )
}
